// Présence globale (anon + auth) via Redis ZSET (/api/presence, /api/online).
// Extrait de app/page.tsx. NB: hook distinct du usePresence chat existant.
import { useEffect, useState } from 'react'
import type { OnlineInfo } from '@/types/landing'

export function useOnlinePresence() {
  const [onlineInfo, setOnlineInfo] = useState<OnlineInfo>({ count: 0, regions: {} })

  useEffect(() => {
    let sessionId = localStorage.getItem('ab_session_id')
    if (!sessionId) {
      sessionId = `anon_${crypto.randomUUID()}`
      localStorage.setItem('ab_session_id', sessionId)
    }

    const fetchOnline = () =>
      fetch('/api/online').then(r => r.json())
        .then(d => setOnlineInfo({ count: d.count ?? 0, regions: d.regions ?? {} }))
        .catch(() => null)

    const sendPresence = (id: string) =>
      fetch('/api/presence', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ sessionId: id }),
      }).catch(() => null)

    sendPresence(sessionId)
    fetchOnline()

    const presenceIv = setInterval(() => sendPresence(sessionId!), 60_000)
    const onlineIv   = setInterval(fetchOnline, 30_000)
    const onVisible  = () => { if (document.visibilityState === 'visible') sendPresence(sessionId!) }
    document.addEventListener('visibilitychange', onVisible)

    return () => {
      clearInterval(presenceIv)
      clearInterval(onlineIv)
      document.removeEventListener('visibilitychange', onVisible)
    }
  }, [])

  return onlineInfo
}
